const ADMIN_INTERFACE_STORAGE_KEY = 'admin-interface-selection';

export type AdminInterfaceSelection = 'office' | 'field-worker';

export function getStoredAdminInterface(): AdminInterfaceSelection | null {
  try {
    if (typeof window === 'undefined') return null;
    const stored = window.localStorage.getItem(ADMIN_INTERFACE_STORAGE_KEY);
    if (stored === 'office' || stored === 'field-worker') {
      return stored;
    }
  } catch {
    // Ignore storage issues and fallback to interface selection.
  }
  return null;
}

export function setStoredAdminInterface(value: AdminInterfaceSelection) {
  try {
    if (typeof window === 'undefined') return;
    window.localStorage.setItem(ADMIN_INTERFACE_STORAGE_KEY, value);
  } catch {
    // Ignore storage issues - app still works without persistence.
  }
}

export function clearStoredAdminInterface() {
  try {
    if (typeof window === 'undefined') return;
    window.localStorage.removeItem(ADMIN_INTERFACE_STORAGE_KEY);
  } catch {
    // Ignore storage issues.
  }
}
